import { Component, Input, OnInit } from '@angular/core';
import { ProductBillingRule, BillingRuleAssignment } from 'src/app/models/productBilling';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductBillingModalComponent } from '../product-billing-modal/product-billing-modal.component';
import { ToastrService } from 'ngx-toastr';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { ClientLocation } from 'src/app/clients-module/models/clientLocation';
import { tap } from 'rxjs/operators';


@Component({
  selector: 'app-product-billing',
  templateUrl: './product-billing.component.html',
  styleUrls: ['./product-billing.component.less']
})
export class ProductBillingComponent implements OnInit {
  @Input() location : ClientLocation;
  constructor(private modalService: NgbModal, public toast : ToastrService, public locations : PropertyService) { }
  public get rules() : ProductBillingRule[] {
    return this.location.productBilling
  }
  
  ngOnInit(): void {
    if (this.rules) {
      this.rules.forEach(r => {
        r = Object.assign(ProductBillingRule, r)
      })
    }
  }

  addRule() {
    // if(this.rules.length > 0){
    //   this.toast.error('Duplicate Product Billing Rules are not supported.');
    //   return;
    // }
    const modalRef = this.modalService.open(ProductBillingModalComponent, { centered: true, size: 'lg' })
    modalRef.componentInstance.name = 'ProductBillingModalComponent';
    modalRef.componentInstance.locationId = this.location.id;
    modalRef.componentInstance.dupeRules = this.rules;
    modalRef.componentInstance.saved.subscribe((evt: boolean) => { 
      this.locations.GetBillingRulesForLocation(this.location.id). pipe(tap(_=>{
        this.location.productBilling = _;
      })).subscribe();
    })
  }

  deleteRule(rule : ProductBillingRule){
    let assn = new BillingRuleAssignment();
    assn.Rule = rule;
    assn.PropertyId = this.location.id;
    this.locations.DeleteBillingRule(assn).subscribe((scc: any)=>{
      this.locations.GetBillingRulesForLocation(this.location.id). pipe(tap(_=>{
        this.location.productBilling = _;
        this.toast.success('Billing Rule added successfully', 'Successful billing rule save')
      })).subscribe();
    },()=>{
      this.toast.error('Could not remove billing rule', 'ERROR removing billing rule');
    })
  }
}
